/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams,Link,useNavigate } from 'react-router-dom';
import axios from "axios";

import "react-datepicker/dist/react-datepicker.css";

import HeaderTitle from "../../components/includes/HeaderTitle";
import { isObjEmpty,ChangeMobileFormat,ChangeMobileNumber,ChangeDateStringOnlyDate } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const StaffCallNetworkDetail = ({setMenuType,setMenuItem}) => {
  let { stc_idx } = useParams();
  const navigator = useNavigate();

  //회원정보
  const [varStaffInfo,setStaffInfo] = useState({});
  //직원목록
  const [varStaffList,setStaffList] = useState([]);
  //소속
  const [varDepartmentList,setDepartmentList] = useState([]);
  //직위
  const [varPositionList,setPositionList] = useState([]);

  //신규회원정보
  const newStaff = {stc_idx:Number(stc_idx),stc_mem_idx:0,stc_mobile:"",stc_rdate:"",stc_status:1,
                  st_department:0,st_position:0};

  //회원정보 읽어오기
  const getStaffCallingNetworkInformation = async () => {
    const sendData = {stc_idx:stc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staff_calling_network_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          setStaffInfo(dataInfo);
        }  else {
          setStaffInfo(newStaff);
        }
        setStaffList(datas.staffs);
        setDepartmentList(datas.departments);
        setPositionList(datas.positions);
      } else {
        setStaffInfo(newStaff);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffCallNetworkList');
    getStaffCallingNetworkInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "stc_mobile") {
      setStaffInfo({...varStaffInfo,stc_mobile:ChangeMobileNumber(value)});
    } else if(name === "stc_mem_idx") {
      const stc_mem_idx = Number(value);
      const staffData = varStaffList.find(el=>el.mem_idx===stc_mem_idx);
      const st_department = staffData.st_department;
      const st_position = staffData.st_position;
      const stc_mobile = staffData.mem_mobile;
      setStaffInfo({...varStaffInfo,stc_mem_idx:stc_mem_idx,st_department:st_department,st_position:st_position,stc_mobile:stc_mobile});
    } else {
      setStaffInfo({...varStaffInfo,[name]:value});
    }
  }

  //직원정보저장
  const onUpdateStaffHandler = async (e) => {
    if(varStaffInfo.stc_mobile === "") {
      alert('이름을 먼저 입력하세요.'); return false;
    } else if(varStaffInfo.stc_mem_idx === 0) {
      alert('소속을 먼저 선택하세요.'); return false;
    }

    if(!window.confirm('위 직원을 연락망에 등록할까요?')) return false;

    const sendData = {staffInfo:varStaffInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_update_staff_calling_network_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      navigator('/Admin/StaffCallNetworkList');
    });
  }

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle="직원 연락망 상세" />
      {isObjEmpty(varStaffInfo)?null:
        <div className="admin-content">
          <div className="main-box">
            <table className="write">
              <colgroup><col width="30%"/><col width="70%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>등록일자</th>
                  <td>{ChangeDateStringOnlyDate(varStaffInfo.stc_rdate)}</td>
                </tr>
                <tr>
                  <th>직원</th>
                  <td>
                    <select name="stc_mem_idx" style={{width:"200px"}} value={varStaffInfo.stc_mem_idx} onChange={onChangeInputHandler}>
                      <option value={0}>직원선택</option>
                      {varStaffList.map((staffs,i)=>(
                        <option key={'staffs_'+i} value={staffs.mem_idx}>{staffs.mem_name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>소속</th>
                  <td>
                    <select name="st_department" style={{width:"200px"}} value={varStaffInfo.st_department} onChange={onChangeInputHandler} disabled>
                      <option value={0}>소속선택</option>
                      {varDepartmentList.map((depart,i)=>(
                        <option key={'depart_'+i} value={depart.vd_idx}>{depart.vd_name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>직위</th>
                  <td>
                    <select name="st_position" style={{width:"200px"}} value={varStaffInfo.st_position} onChange={onChangeInputHandler} disabled>
                      <option value={0}>직위선택</option>
                      {varPositionList.map((position,i)=>(
                        <option key={'position_'+i} value={position.vp_idx}>{position.vp_name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>연락처</th>
                  <td><input type="text" name="stc_mobile" style={{width:"300px"}} value={ChangeMobileFormat(varStaffInfo.stc_mobile)} onChange={onChangeInputHandler}/></td>
                </tr>   
                <tr>
                  <th>상태</th>
                  <td>
                    <select name="mem_status" value={varStaffInfo.stc_status} style={{width:"200px"}} onChange={onChangeInputHandler}>
                      <option value={0}>종료</option>
                      <option value={1}>사용중</option>
                    </select>
                  </td>
                </tr>       
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <button className="btn line black" style={{width:"100px"}} onClick={(e)=>onUpdateStaffHandler(e)}>저장</button>
            <Link to={`/Admin/StaffCallNetworkList`} className="btn-danger">목록</Link>
          </div>
        </div>
      }
    </div>   
  );
}
export default StaffCallNetworkDetail;